import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './login.js';
import OauthLogin from './oauth-login.js';
import Signup from './signup.js';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Router basename="/shopify">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
    </Router>
    <Router basename="/oauth">
      <Routes>
        <Route path="/authorize" element={<OauthLogin />} />
      </Routes>
    </Router>
  </>
);
